<template>
  <button :id="cpntId" :class='classButton' :data-time='time' :disabled='cpntStatus !== ""' @click.stop.prevent="onClickButton" v-show='cpntMostrar' :tabIndex='cpntTabIndex' :title="cpntTitle" :key="'status-' + cpntStatus">
    <template v-if='cpntStatus !== ""'>
      <RF-Status :cpntStatus='cpntStatus' :cpntTamanho='1' :cpntFrase='false' :cpntIcone='true' style='color: #000;'></RF-Status>
    </template>
    <template v-else>
      <template v-if='cpntTipo === "excluir"'>
        <RF-Icones
          :cpntId='cpntId + "-icone"'
          :cpntIcone='"excluir"'
          :cpntIconeClass='cpntIcone.class'
          :cpntExplica='cpntIcone.explica'
        ></RF-Icones>
      </template>
      <template v-else-if='cpntTipo === "editar"'>
        <RF-Icones
          :cpntId='cpntId + "-icone"'
          :cpntIcone='"editar"'
          :cpntIconeClass='cpntIcone.class'
          :cpntExplica='cpntIcone.explica'
        ></RF-Icones>
      </template>
      <template v-else-if='cpntTipo === "cancelar"'>
        <RF-Icones
          :cpntId='cpntId + "-icone"'
          :cpntIcone='"cancelar"'
          :cpntIconeClass='cpntIcone.class'
          :cpntExplica='cpntIcone.explica'
        ></RF-Icones>
      </template>
      <template v-else-if='cpntTipo === "modificar"'>
        <RF-Icones
          :cpntId='cpntId + "-icone"'
          :cpntIcone='"modificar"'
          :cpntIconeClass='cpntIcone.class'
          :cpntExplica='cpntIcone.explica'
        ></RF-Icones>
      </template>
      <template v-else-if='cpntTipo === "sync"'>
        <RF-Icones
          :cpntId='cpntId + "-icone"'
          :cpntIcone='"sync"'
          :cpntIconeClass='cpntIcone.class'
          :cpntExplica='cpntIcone.explica'
        ></RF-Icones>
      </template>
      <template v-else-if='cpntTipo === "reativar"'>
        <i class="fa fa-level-up-alt" aria-hidden="true"></i>
      </template>
      <template v-else-if='cpntTipo === "reenviar"'>
        <i class="fa fa-paper-plane" aria-hidden="true"></i>
      </template>
      <template v-else-if='cpntTipo === "copiar"'>
        <i class="far fa-copy" aria-hidden="true"></i>
      </template>
      <template v-else-if='cpntTipo === "fechar"'>
        <i class="fa fa-times" aria-hidden="true"></i>
      </template>
      <template v-else-if='cpntTipo === "icone"'>
        <RF-Icones
          :cpntId='cpntId + "-icone"'
          :cpntIcone='cpntIcone.tipo'
          :cpntIconeClass='cpntIcone.class'
          :cpntExplica='cpntIcone.explica'
        ></RF-Icones>
      </template>
      <template v-else-if='cpntTipo === "texto-icone"'>
        <span v-html='cpntTexto'></span>

        <RF-Icones
          :cpntId='cpntId + "-icone"'
          :cpntIcone='cpntIcone.tipo'
          :cpntIconeClass='cpntIcone.class'
          :cpntExplica='cpntIcone.explica'
        ></RF-Icones>
      </template>
      <template v-else-if='cpntTipo === "icone-texto"'>
        <RF-Icones
          :cpntId='cpntId + "-icone"'
          :cpntIcone='cpntIcone.tipo'
          :cpntIconeClass='cpntIcone.class'
          :cpntExplica='cpntIcone.explica'
        ></RF-Icones>

        <span v-html='cpntTexto'></span>
      </template>
      <template v-else-if='cpntIcone !== "" && cpntTexto !== ""'>
        <i :class='cpntIcone' aria-hidden="true"></i>
        <div v-html='cpntTexto'></div>
      </template>
      <template v-else-if='cpntIcone !== ""'>
        <i :class='cpntIcone' aria-hidden="true"></i>
      </template>
      <template v-else>
        <div v-html='cpntTexto'></div>
      </template>

      <slot name="conteudo"></slot>
    </template>
  </button>
</template>

<style scoped>
  button > span ~ .rf-icone {
    margin-right: 5px;
  }
  button > .rf-icone ~ span {
    margin-left: 5px;
  }
</style>

<script>
  export default {
    name: 'RF-Button',
    components: {
      'RF-Icones': () => import('@/components/rf-geral/icones/RF-Icones.vue')
    },
    props: {
      cpntStatus: {
        required: false,
        default: function () {
          return ''
        }
      },
      cpntId: {
        required: false,
        type: String,
        default: function () {
          // INICIA A VARIAVEL ID
          var id = ''

          // INICIA PARA VERIFICAR SE ENCONTROU UM ID
          var flag = false

          while (flag === false) {
            // GERA UM ID PARA O CAMPO
            id = 'cpnt-button-' + (Math.floor(Math.random() * (9999 - 1000)) + 1000).toString() + '--'

            // VERIFICA SE O ID GERADO É UNICO NA TELA
            flag = [ '', null, undefined ].indexOf(document.getElementById(id)) !== -1
          }

          // RETONAR O VALOR MONTADO
          return id
        }
      },
      cpntTexto: {
        required: false,
        type: String
      },
      cpntClass: {
        required: false,
        type: [ String, Array ],
        default: function () {
          return [ 'btn', 'btn-default' ]
        }
      },
      cpntIcone: {
        required: false,
        type: [ String, Object, Array ],
        default: function () {
          return ''
        }
      },
      cpntTabIndex: {
        required: false,
        type: Number,
        default: function () {
          return 0
        }
      },
      cpntTitle: {
        required: false,
        type: String,
        default: function () {
          return ''
        }
      },
      cpntTipo: {
        required: false,
        type: String,
        default: function () {
          return ''
        }
      },
      cpntDisabled: {
        required: false,
        type: Boolean,
        default: function () {
          return false
        }
      },
      cpntMostrar: {
        type: Boolean,
        required: false,
        default: function () {
          return true
        }
      },
      cpntExplica: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    data: function () {
      return {
        time: 0,
        classButton: [],
        timeFlag: 0
      }
    },
    mounted: function () {
      var self = this

      self.onCheckDisabledButton()

      self.criarQtipButton()

      setTimeout(function () {
        $('#' + self.cpntId).on('mousedown', function (event) {
          event.stopPropagation()
          event.preventDefault()

          if (event.which === 2) {
            // REALIZA O PREVENT DEFAULT
            event.preventDefault()

            // SETA O CLICK NO SCROLL
            self.$store.commit('SET_BUTTON_CLICK_SCROLL', self.cpntId)

            // CHAMA A FUNÇÃO PARA DAR O CLICK NO BUTTON
            self.onClickButton(event)
          }
        })
      }, 500)
    },
    methods: {
      onCheckDisabledButton: function () {
        var self = this
        if (self.timeFlag === 0) {
          self.timeFlag = 1
          setTimeout(function () {
            self.timeFlag = 0
          }, 500)

          // LIMPA AS CLASSES DO BUTTONS
          self.classButton = [ ]

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          if (typeof self.cpntClass === 'string') {
            self.classButton = self.cpntClass.split(' ')
          } else {
            self.classButton = self.cpntClass
          }

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          if (self.cpntDisabled === true) {
            self.classButton.push('rf-button-disabled')
          } else {
            self.classButton = self.classButton.filter(item => item !== 'rf-button-disabled')
          }

          // REMOVE CLASSES DUPLICADAS
          self.classButton = self.classButton.filter((v, i, a) => a.indexOf(v) === i)

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()
        }
      },
      onClickButton: function (event) {
        event.stopPropagation()
        event.preventDefault()

        if (this.cpntDisabled === false) {
          if (this.cpntExplica !== null && Object.keys(this.cpntExplica).length >= 1) {
            var idQtip = '#' + this.cpntId
            $(idQtip).qtip('hide')
          }

          this.$emit('onClickButton', this.cpntId)
        }
      },
      criarQtipButton: function () {
        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        var self = this

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // DESTROI O QTIP SE ELE EXISITR
        $('#' + self.cpntId).qtip('destroy', true)
        
        if ([ '', null, undefined ].indexOf(self.cpntExplica) === -1 && Object.keys(self.cpntExplica).length >= 1 && [ '', null, undefined ].indexOf(self.cpntExplica.mensagem) === -1) {
          var chavesIniciais = {
            mensagem: '',
            titulo: '',
            positionMy: 'top left',
            positionAt: 'bottom right',
            classes: 'rf-qtip'
          }

          // SETA OS VALOORE E PADROES PARA O QTIP
          for (var key in chavesIniciais) {
            if (!self.cpntExplica.hasOwnProperty(key)) {
              self.cpntExplica[key] = chavesIniciais[key]
            }
          }

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          setTimeout(function () {
            $('#' + self.cpntId).qtip({
              content: {
                text: self.cpntExplica.mensagem,
                title: self.cpntExplica.titulo
              },
              position: {
                my: self.cpntExplica.positionMy,
                at: self.cpntExplica.positionAt
              },
              style: {
                classes: self.cpntExplica.classes
              }
            })
          }, 300)
        }
      }
    },
    watch: {
      'cpntDisabled': function () {
        this.onCheckDisabledButton()

        if (this.cpntDisabled === true) {
          this.classButton.push('rf-button-disabled')
        } else {
          this.classButton = this.classButton.filter(item => item !== 'rf-button-disabled')
        }
      },
      'cpntClass': function () {
        this.onCheckDisabledButton()
      },
      'cpntExplica': function () {
        this.criarQtipButton()
      }
    }
  }
</script>
